import { computed, makeObservable, observable } from "mobx"
import { succubus_data_DataLine } from "react-sdk/haxelibs/datamanagertypes.d.ts"
import Chapters from "./Chapters"
import AppState from "./AppState"
import Minigames from "./Minigames/Minigames"

class Chapter {

  /**
   * @type {succubus_data_DataLine}
   */
  line = null

  /**
   * nombre d'étoiles obtenu (sauvegardé)
   */
  stars = 0

  /**
   * Indique si le chapitre est terminé (sauvegardé)
   */
  finished = false

  /**
   * Indique si le chapitre est en cours (sauvegardé)
   */
  inProgress = false

  /**
   * Indique si le chapitre est lock par la date (sauvegardé)
   */
  dateLocked = true

  minigames = []

  /**
   * Nombre d'étoiles max gagnable dans le chapitre
   */
  maxStars

  starsThreshold1
  starsThreshold2
  starsThreshold3

  /** @type {Date} */
  #unlockDate = null

  constructor(dataLine) {
    this.line = dataLine
    makeObservable(this, {
      stars : observable,
      finished : observable,
      inProgress : observable,
      dateLocked : observable
    })

    let dateStr = this.line.get("unlockDate")
    if (dateStr)
      this.#unlockDate = new Date(dateStr)
    
    this.#checkDateUnlock()
    
  }

  initMgValues() {
    this.minigames = Minigames.all.filter((mg) => mg.chapter == this)
    this.maxStars = this.minigames.reduce((total, mg) => total + mg.scoreFactor, 0)
    this.starsThreshold1 = Math.round(this.threshold1 * this.maxStars / 100)
    this.starsThreshold2 = Math.round(this.threshold2 * this.maxStars / 100)
    this.starsThreshold3 = Math.round(this.threshold3 * this.maxStars / 100)
  }

  get id() {
    return this.line.id;
  }
  get name() {
    return this.line.get("name");
  }
  get description() {
    return this.line.get("description");
  }
  get unlockDate() {
    return this.#unlockDate;
  }
  get unlockDateText() {
    return this.line.get("unlockDateText");
  }
  get image() {
    return this.line.get("image");
  }
  get scriptTrigger() {
    return this.line.get("scriptTrigger");
  }
  get threshold1() {
    return this.line.get("threshold_1");
  }
  get threshold2() {
    return this.line.get("threshold_2");
  }
  get threshold3() {
    return this.line.get("threshold_3");
  }
  get endTitle() {
    return this.line.get("endTitle");
  }
  get endText() {
    return this.line.get("endText");
  }
  get isLast() {
    return this.id == "3";
  }

  refreshStars() {
    this.stars = this.minigames.reduce((total, mg) => total + mg.getStars(), 0)
  }

  #checkDateUnlock() {
    if (this.#unlockDate) {
      this.dateLocked = new Date() < this.#unlockDate
      if (this.dateLocked) {
        setTimeout(() => this.dateLocked = false, this.#unlockDate.getTime() - Date.now())
      }
    } else
      this.dateLocked = false

  }

}

export default Chapter